<div class="py-12 px-8 text-base mx-auto md:max-w-2xl">
  <p class="text-center"><b>ANEXO I</b></p>
  <p class="text-center">
    <b> DO NÍVEL DE SERVIÇO (“SLA”), DAS GARANTIAS E DO SUPORTE </b>
  </p>
  <p  class="text-justify my-6">
    <b>1)</b> Ressalvadas as disposições nos itens abaixo relativas às
    atualizações, a Plataforma é contratada
    <i>“na forma em que se encontra”</i> e <i> “conforme a disponibilidade”</i>,
    estando a Anunciante plenamente ciente de que, não obstante os esforços da
    Desenvolvedora, a Plataforma poderá, por sua natureza, (i) não estar
    disponível 100% do tempo, (ii) sofrer invasões de terceiros, (iii) não
    registrar adequadamente as atividades dos usuários e Clientes, (iv) sofrer
    algum vazamento ou perda inesperada de dados ou configurações, (v) conter
    conteúdo inapropriado, arquivos maliciosos, defeitos e/ou vírus. Assim, a
    Anunciante exonera a Desenvolvedora de toda e qualquer responsabilidade
    decorrente de danos oriundos das situações descritas nesta cláusula ou de
    ocorrências similares.
  </p>

  <p  class="text-justify mb-6">
    <b>2)</b> A Desenvolvedora mantém uma política de constante atualização de
    sua tecnologia, lançando pacotes e novas versões da Plataforma, de
    implementação obrigatória, que consideram necessidades e interesses comuns
    de seus Clientes, correções e incrementos evolutivos para melhor
    funcionamento da Plataforma. Sempre que a comunicação se mostrar necessária
    ou os impactos forem significativos, a Desenvolvedora informará a Anunciante
    sobre a ocorrência e teor destas atualizações.
  </p>

  <p  class="text-justify mb-6">
    <b>3)</b> A implementação das novas versões pode demandar a atualização de
    navegadores e outras tecnologias presentes nos dispositivos dos usuários da
    Plataforma.
  </p>
  <p  class="text-justify mb-6">
    <b>4)</b> A Desenvolvedora empreenderá esforços razoáveis para que a
    Plataforma fique disponível por, no mínimo, 99% (noventa e nove por cento)
    do tempo, durante cada ano de serviço.
    <span class="block ml-6 my-6">
      <b>a)</b> o ano do serviço compreende os 365 dias precedentes à data de
      uma reivindicação de indisponibilidade; <br />
      <br />
      <b>b)</b> na hipótese da Desenvolvedora não cumprir o nível de
      <i>uptime</i> da Plataforma, a Anunciante terá direito, exclusivamente, ao
      uso gratuito da Plataforma por um número de minutos equivalente ao período
      adicional de indisponibilidade; <br /><br />
      <b>c)</b> se o período de utilização da Plataforma pela Anunciante for
      inferior a 365 dias, os dias de não utilização serão considerados como
      tendo 100% de disponibilidade; <br /><br />
      <b>d)</b> após o pagamento do crédito referente à reivindicação de
      indisponibilidade, o período será considerado 100% disponível para efeito
      de futuras reivindicações.
    </span>
  </p>

  <p  class="text-justify mb-6">
    <b>5)</b> Não serão consideradas indisponibilidades:
    <span class="block ml-6 my-6">
      <b>a)</b> Manutenções emergenciais entre 00:00h e 08:00h, que não
      ultrapassem 2 (duas) horas; <br />
      <br />
      <b>b)</b> Eventos de força maior ou caso fortuito; <br /><br />
      <b>c)</b> Problemas relacionados à conectividade da Internet como um todo;
      <br /><br />
      <b>d)</b> Quaisquer atos ou omissões da Anunciante, dos Clientes ou de
      terceiros que provoquem ou contribuam para a indisponibilidade;
      <br /><br />
      <b>e)</b> Equipamentos, softwares e outras tecnologias que impeçam o
      acesso à Plataforma e não estejam na esfera de responsabilidade da
      Desenvolvedora; <br /><br />
      <b>f)</b> Falhas de instâncias individuais não relacionadas com a
      indisponibilidade do serviço, mas sim com a instância da Anunciante ou
      Clientes.
    </span>
  </p>
  <p  class="text-justify mb-6">
    <b>6)</b> As Partes têm ajustado as seguintes condições acerca das garantias
    oferecidas pela Desenvolvedora em relação à Plataforma.
    <br />
    <span class="block ml-6 my-6">
      <b>a)</b> por ter sido a Plataforma desenvolvida para atender as mais
      diversas demandas dos mais diversos usuários, a Desenvolvedora não garante
      que a mesma atenda à uma necessidade específica da Anunciante; <br />
      <br />
      <b>b)</b> a Desenvolvedora não garante que a Plataforma seja compatível
      com qualquer outro software, dispositivo e/ou plataforma. <br /><br />
    </span>
  </p>
  <p  class="text-justify mb-6">
    <b>7)</b> As Partes têm ajustado as seguintes condições acerca do suporte
    oferecido pela Desenvolvedora em relação à Plataforma:
    <span class="block ml-6 my-6">
      <b>a)</b> O suporte à utilização da Plataforma será fornecido somente em
      dias úteis, durante horário comercial, conforme fuso horário de Brasília,
      através do telefone (51) 35173206 ou do e-mail
      lucas.almeida&#64;mobo.com.br;<br />
      <br />
      <b>b)</b> O prazo de resposta é de até 48 (quarenta e oito) horas úteis,
      não estando incluído neste prazo a solução de eventuais defeitos, erros ou
      problemas da Plataforma, que ficará ao critério exclusivo da
      Desenvolvedora, que poderá inclusive optar por não corrigir o referido
      defeito, erro ou problema, sem que isso enseje qualquer inadimplemento
      contratual. <br />
      <br />
    </span>
  </p>
</div>
